import React, { useCallback } from 'react'

import { Modal, ModalContent, ModalContentInner, ModalHeader } from 'ui/components/Modal'
import { GlobalModal, useGlobalModalState } from 'ui/components/Modal/useGlobalModal'
import { theme } from 'ui/styling/Theme.css'

import { FileUpload } from './FileUpload'
import { UploadedFile } from './types'

export type FileUploadModalData = React.ComponentPropsWithoutRef<typeof FileUpload> & {
    zIndex?: number
    closeOnUpload?: boolean
    modal?: boolean
}

type FileUploadModalProps = {}

export const FileUploadModal: GlobalModal<FileUploadModalData, FileUploadModalProps> = (props) => {
    const { isOpen, onOpenChange, data } = useGlobalModalState(FileUploadModal, props)

    const {
        maxFiles = 1,
        onUploadSuccess: onUploadSuccessProp,
        zIndex,
        closeOnUpload = true,
        modal = true,
        ...fileUploadProps
    } = data ?? {}

    const onUploadSuccess = useCallback(
        (files: UploadedFile[]) => {
            if (closeOnUpload) {
                // Wait for the animation to complete.
                setTimeout(() => {
                    onOpenChange(false)
                    onUploadSuccessProp?.(files)
                }, 450)
            } else {
                onUploadSuccessProp?.(files)
            }
        },
        [closeOnUpload, onOpenChange, onUploadSuccessProp]
    )

    return (
        <Modal open={isOpen} onOpenChange={onOpenChange} modal={modal}>
            <ModalContent
                style={{
                    width: '500px',
                    maxWidth: '90%',
                }}
                zIndex={zIndex}
            >
                <ModalHeader title="Upload files" />
                <ModalContentInner
                    style={{
                        paddingBottom: theme.modal.padding.container,
                    }}
                >
                    <FileUpload
                        maxFiles={maxFiles}
                        onUploadSuccess={onUploadSuccess}
                        {...fileUploadProps}
                    />
                </ModalContentInner>
            </ModalContent>
        </Modal>
    )
}
